import { userService } from '@saucelabs/sl-util-axios';

export const createUser = ({ firstName, lastName, organizationId, ...params }) => {
  const data = {
    first_name: firstName,
    last_name: lastName,
    organization: organizationId,
    ...params,
  };

  return userService.post('/v1/users/', data);
};

export const createInvitation = ({ organizationId, ...params }) => {
  const data = {
    organization: organizationId,
    ...params,
  };
  return userService.post('/v1/invitations/', data);
};

export const getRoles = () => (
  userService.get('/v1/rbac/roles/')
);
